import { render } from "./FirstView.vue?vue&type=template&id=dcf2dac2"
import script from "./FirstView.vue?vue&type=script&lang=js"
export * from "./FirstView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\emad_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__